import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckCircleIcon, XCircleIcon, ClockIcon } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const included = ['Ebook Maestro Código Longevidad', 'Plan Blindaje: 12 semanas programadas', 'Guía de Postura para Oficinistas', 'Videos demostrativos de cada ejercicio', 'Protocolos de recuperación optimizados', 'Guía de suplementación basada en evidencia', 'Acceso de por vida a actualizaciones'];
  const notIncluded = ['Membresía mensual recurrente', 'Equipamiento costoso requerido', 'Sesiones presenciales obligatorias'];
  return <section id="oferta" ref={ref} className="w-full bg-bg-secondary py-20 px-4 sm:px-6 lg:px-8" data-id="element-97">
      <div className="max-w-5xl mx-auto" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-99">
          <div className="inline-flex items-center gap-2 bg-red-900/20 border border-red-500/30 rounded-sm px-4 py-2 mb-6" data-id="element-100">
            <ClockIcon className="w-5 h-5 text-red-400" data-id="element-101" />
            <span className="text-red-400 font-heading text-lg" data-id="element-102">
              Oferta de Lanzamiento
            </span>
          </div>

          <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-text-primary mb-6" data-id="element-103">
            Tu inversión en{' '}
            <span className="text-accent-bronze" data-id="element-104">autonomía</span>
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto font-body" data-id="element-105">
            El precio de una cena afuera. La diferencia entre dependencia y
            libertad.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-br from-accent-bronze/10 via-bg-primary to-bg-primary border-2 border-accent-bronze rounded-sm overflow-hidden" data-id="element-106">
          {/* Price header */}
          <div className="bg-accent-bronze/20 border-b border-accent-bronze/30 p-8 text-center" data-id="element-107">
            <p className="text-text-muted font-body text-sm mb-2 line-through" data-id="element-108">
              Valor regular: $28,99 USD
            </p>
            <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-109">
              <span className="font-heading text-6xl sm:text-7xl text-accent-gold" data-id="element-110">
                $6,39
              </span>
              <span className="text-text-secondary font-body text-xl" data-id="element-111">USD</span>
            </div>
            <p className="text-text-secondary font-body text-lg" data-id="element-112">
              Pago único • Acceso de por vida
            </p>
          </div>

          {/* What's included */}
          <div className="p-8 sm:p-10" data-id="element-113">
            <h3 className="font-heading text-3xl text-text-primary mb-6 text-center" data-id="element-114">
              Protocolo Completo Incluye:
            </h3>

            <div className="space-y-4 mb-8" data-id="element-115">
              {included.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.3 + index * 0.1
            }} className="flex items-start gap-3" data-id="element-116">
                  <CheckCircleIcon className="w-6 h-6 text-accent-bronze flex-shrink-0 mt-0.5" data-id="element-117" />
                  <span className="text-text-primary font-body text-lg" data-id="element-118">
                    {item}
                  </span>
                </motion.div>)}
            </div>

            <div className="border-t border-accent-bronze/20 pt-6 mb-8" data-id="element-119">
              <h4 className="font-heading text-xl text-text-secondary mb-4" data-id="element-120">
                No incluye:
              </h4>
              <div className="space-y-3" data-id="element-121">
                {notIncluded.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-122">
                    <XCircleIcon className="w-5 h-5 text-text-muted flex-shrink-0 mt-0.5" data-id="element-123" />
                    <span className="text-text-muted font-body" data-id="element-124">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="text-center" data-id="element-125">
              <CTAButton size="large" onClick={() => {
              trackAddToCart();
              window.location.href = 'https://www.consejossimples.com/cart/53406630216013:1';
            }} data-id="element-126">
                Acceder al Protocolo Completo
              </CTAButton>
              <p className="text-text-muted font-body text-sm mt-4" data-id="element-127">
                Pago seguro • Acceso inmediato • Garantía de 30 días
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 text-center" data-id="element-128">
          <div className="bg-bg-primary border border-accent-bronze/20 rounded-sm p-6" data-id="element-129">
            <p className="font-heading text-4xl text-accent-bronze mb-2" data-id="element-130">
              $0,53
            </p>
            <p className="text-text-secondary font-body text-sm" data-id="element-131">
              por semana durante 12 semanas
            </p>
          </div>
          <div className="bg-bg-primary border border-accent-bronze/20 rounded-sm p-6" data-id="element-132">
            <p className="font-heading text-4xl text-accent-bronze mb-2" data-id="element-133">
              $0,18
            </p>
            <p className="text-text-secondary font-body text-sm" data-id="element-134">
              por día de entrenamiento
            </p>
          </div>
          <div className="bg-bg-primary border border-accent-bronze/20 rounded-sm p-6" data-id="element-135">
            <p className="font-heading text-4xl text-accent-bronze mb-2" data-id="element-136">$0</p>
            <p className="text-text-secondary font-body text-sm" data-id="element-137">
              en membresías recurrentes
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}